<template>
	<div class="container-fluid">
		<h1 class="mb-3">{{ $t("feedback") }}</h1>
		<div class="row">
			<div class="col-md-6 " v-if="$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS')">
				<div
					@click="selectStudent('add')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('add-feedback') }}</h3>
						<p class="mb-0">{{ $t('add-feedback-for-a-student') }}</p>
					</div>
				</div>

				<div
					v-if="$UserSession.hasPriv.call(this, 'REPORT_MYTREATMENTSESSIONFEEDBACK')"
					@click="$router.push('/feedback/studentfeedback')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
                >
					<div class="list-group-item list-group-header">
						<h3>{{ $t('treatment-session-feedback') }}</h3>
						<p class="mb-0">{{ $t('view-my-treatment-session-feedback-from-students') }}</p>
					</div>
				</div>

                <div
					v-if="$UserSession.hasPriv.call(this, 'REPORT_TEACHERFEEDBACK') 
                    && $UserSession.hasPriv.call(this, 'APP_ALLTEACHERS')"
					@click="selectTeacher('list')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
                >
					<div class="list-group-item list-group-header">
						<h3>{{ $t('teacher-feedback') }}</h3>
						<p class="mb-0">{{ $t('view-feedback-for-a-teacher') }}</p>
					</div>
				</div>

				<div
					v-if="$UserSession.hasPriv.call(this, 'REPORT_STUDENTFEEDBACK')"
					@click="selectStudent('list')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
                >
					<div class="list-group-item list-group-header">
						<h3>{{ $t('student-feedback') }}</h3>
						<p class="mb-0">{{ $t('view-feedback-for-a-student') }}</p>
					</div>
				</div>

                <div
                    v-if="$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS')"
					@click="selectStudent('patient')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
                >
					<div class="list-group-item list-group-header">
						<h3>{{ $t('patient-feedback-on-student') }}</h3>
						<p class="mb-0">{{ $t('view-patient-feedback-for-a-student') }}</p>
					</div>
				</div>
			</div>

            <div v-if="$UserSession.hasPriv.call(this, 'VIEW_PATIENTFEEDBACKFORSTUDENT') && !$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS')"
                class="col-md-6"
            >
				<div
					@click="$router.push('/feedback/patientfeedback')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header list-group-item">
						<h3>{{ $t('patient-feedback') }}</h3>
						<p class="mb-0">{{ $t('view-patient-feedback-on-my-treatment-sessions') }}</p>
					</div>
				</div>
			</div>

			<div class="col-md-6">
				<div
					@click="$router.push('/messages/seriousconcern')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm danger"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header list-group-item-danger">
						<h3>{{ $t('serious-concern') }}</h3>
						<p class="mb-0">{{ $t('raise-a-serious-concern-about-a-student-or-member-of-staff') }}</p>
					</div>
				</div>
			</div>

		</div>

		<template v-if="!this.$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS')">
			<h2>{{ $t('my-feedback') }}</h2>
			<InfiniteScroll
				scrollElementId="main"
				type="Feedbacktext"
				:dataUrl="`${$settings.APIBaseURL}/feedbacktext/listformsandtext`"
				dataProperty="results"
				class="list-group border-radius-2 no-border"
				itemClass="list-group-item"
				ref="infinitescroll"
			/>
		</template>

	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";
export default {
	components: {
		InfiniteScroll,
	},
	data() {
		return {
		}
	},
	mounted() {
		this.getFeedback();
	},
	methods: {
		selectStudent(action) {
			if(this.$UserSession.hasPriv.call(this, 'APP_ALLSTUDENTS')){
				const self = this;
				this.$users.getStudents.call(this).then(students => {
					this.$store.commit("openModal", {
						type: "selector",
						title: this.$t("select-a-student"),
						selectCallback: function(selection) {
							self.$store.commit("closeModal");
							action === 'add' 
							? self.$router.push(`/feedback/new/${selection.id}`) 
							: action === 'list'
							? self.$router.push(`/feedback/list/${selection.id}`)
							: action === 'patient'
							? self.$router.push(`/feedback/patientfeedback/${selection.id}`)
							: undefined;
						},
						selected: [
						],
						data: students,
						captionKey: "displayName",
                        subcaptionKey: "studentid",
						studentSearchFilters: true
					});
				});
			}
		},
        selectTeacher() {
			if (this.$UserSession.hasPriv.call(this, 'APP_ALLTEACHERS')) {
				const self = this;
				this.$users.getTeachers.call(this).then(teachers => {
				const processedTeachers = teachers.map(teacher => {
					if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)");
					}
					return teacher;
				});
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-teacher"),
					selectCallback: function(selection) {
					self.$store.commit("closeModal");
					self.$router.push(`/feedback/studentfeedback/${selection.id}`);
					},
					selected: [],
					data: processedTeachers,
					captionKey: "displayName",
					subcaptionKey: "subcaption",
					studentSearchFilters: false
				});
				});
			}
		},

		getFeedback(){
			let body = {};
			/*
			if(this.search.q){
				body = {
					q: this.search.q
				}
			}
			*/
			this.$refs.infinitescroll ? this.$refs.infinitescroll.getData("replace", body) : undefined;
		}
	}
};
</script>